export const numericToBool = (v: 0 | 1 | undefined): boolean | null => {
  return typeof v === 'number' ? Boolean(v) : null;
};
